import { type SelectorFunction } from '@aikoa/i18n'
import { useTranslations } from '@aikoa/i18n/react'
import { Trans } from '@aikoa/i18n/react'
import { type ReactNode } from 'react'
import { RoughNotation } from 'rough-notation-native'
import designTokens from '~/lib/designTokens'
import { cn } from '~/lib/utils'
import { Text } from '../ui/text'

export function TransUnderlinedText({
  className,
  i18nKey,
  delay = 1000,
  animate = true,
}: {
  i18nKey: SelectorFunction<'home'>
  className?: string
  delay?: number
  animate?: boolean
}) {
  const { t } = useTranslations('home')

  return (
    <Text className={cn(className)}>
      <Trans
        t={t}
        i18nKey={i18nKey}
        components={{
          underline: ({ children, key }) => (
            <UnderlinedText key={key} animate={animate} delay={delay} className={className}>
              {children}
            </UnderlinedText>
          ),
        }}
      />
    </Text>
  )
}

export function UnderlinedText({
  className,
  children,
  animate = true,
  delay = 1000,
}: {
  className?: string
  children: ReactNode
  animate?: boolean
  delay?: number
}) {
  return (
    <RoughNotation
      type="underline"
      color={designTokens.accent}
      animate={animate}
      animationDelay={delay}>
      <Text className={className}>{children}</Text>
    </RoughNotation>
  )
}
